import DetailHeader from "./detailHeader/DetailHeader";
import PaymentDetailsMobile from "./paymentDetailsMobile/PaymentDetailsMobile";
import PaymentDetails from "./paymentDetails/PaymentDetails";

export { DetailHeader, PaymentDetailsMobile, PaymentDetails };



// WEBPACK FOOTER //
// ./src/components/statement/index.js